module.exports = __webpack_public_path__ + "img/TractionAndroid3.b6db553e.png";